import { LogoLight } from 'src/components/Svg/Images';
import { cn } from 'src/lib/utils';
import env from 'env';

import { AuthSupport } from './ui';

type Props = {
  topBar?: React.ReactNode;
  wide?: boolean;
  formOnly?: boolean;
};

const AuthShell = ({ children, topBar, wide = false, formOnly = false }: React.PropsWithChildren<Props>) => {
  if (formOnly) {
    return (
      <div className={cn('w-full mx-auto p-6', wide ? 'max-w-190' : 'max-w-105')}>
        {topBar}
        {children}
        <AuthSupport />
      </div>
    );
  }

  return (
    <div className="grid grid-cols-[480px_1fr] min-h-screen bg-background">
      <aside className="relative flex flex-col justify-between gap-6 overflow-hidden p-10 text-white bg-[linear-gradient(180deg,#0E465A_0%,#093642_100%)]">
        <div className="flex items-center gap-3">
          <LogoLight className="w-55 h-12" />
        </div>

        <div className="relative max-w-90">
          <h2 className="text-[28px] leading-tight text-white mb-3">
            Software resilience,
            <br />
            end to end.
          </h2>
          <p className="text-sm leading-relaxed text-white/78">
            Keep the software you build — and rely on — recoverable and ready. Proof of resilience your regulators and
            clients can trust.
          </p>
        </div>

        <div className="flex shrink-0 flex-wrap items-center gap-5 text-xs text-white/65">
          <span>© {new Date().getFullYear()} Codekeeper, Inc. All rights reserved.</span>
          <ul className="flex gap-4">
            <li>
              <a
                href={env.CODEKEEPER_TERMS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-white/70 hover:underline"
              >
                Terms
              </a>
            </li>
            <li>
              <a
                href={env.CODEKEEPER_PRIVACY_POLICY_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-white/70 hover:underline"
              >
                Privacy
              </a>
            </li>
          </ul>
        </div>
      </aside>

      <main
        className={cn(
          'flex flex-col items-center overflow-auto px-6 pt-10 pb-6',
          topBar ? 'justify-start' : 'justify-center',
        )}
      >
        {topBar && <div className={cn('w-full shrink-0', wide ? 'max-w-190' : 'max-w-lg')}>{topBar}</div>}
        <div className={cn('w-full flex-1 flex flex-col justify-center', wide ? 'max-w-190' : 'max-w-lg')}>
          {children}
          <AuthSupport />
        </div>
      </main>
    </div>
  );
};

export default AuthShell;
